import { IResponsesValue, IValidationUserResponses, IValidationItem } from 'types'
import { pick } from 'lodash'
import { IDidYouKnowResponses, IDidYouKnowResponsesValidations } from './Interface'

import UserResponseManagerService from 'smart-components/user-responses-manager/Service'

export default class DidYouKnowService {
  static readonly SECTION_KEYS: string[] = [
    'statNum',
    'statDetail',
    'funFact',
    'randomJob',
    'uniqueInterest',
    'tedTalk',
    'projectToLife'
  ]

  static selectDidYouKnowResponses(currentResponse: IResponsesValue): IDidYouKnowResponses {
    return pick(currentResponse, DidYouKnowService.SECTION_KEYS) as IDidYouKnowResponses
  }

  static selectValidationKeys(validations: IValidationUserResponses): IDidYouKnowResponsesValidations {
    if (!validations?.responses) {
      return {} as IDidYouKnowResponsesValidations
    }

    return Object.entries(validations.responses)
      .filter(([key]) => DidYouKnowService.SECTION_KEYS.includes(key))
      .reduce((acc, [key, result]: [string, IValidationItem]) => {
        result.stack = result.valid ? '' : result.stack.replace('"value"', 'answer')
        return {
          ...acc,
          [key]: result
        }
      }, {} as IDidYouKnowResponsesValidations) as IDidYouKnowResponsesValidations
  }

  static async updateQuestionAnswer(questionKey: string, response: string): Promise<string | null> {
    if (!DidYouKnowService.SECTION_KEYS.includes(questionKey)) {
      throw new Error(`The question key "${questionKey}" is not valid for the did you know section.`)
    }
    return UserResponseManagerService.updateResponse({ questionKey, response })
  }
}
